import { FieldValueDisplay } from "./field-value-display";
import { FieldValueEditor } from "./field-value-editor";
import type { FieldData, FieldValue } from "../types";

type Props = {
  field: FieldData;
  isEditing: boolean;
  hasPendingChange: boolean;
  displayValue: string;
  editValue: FieldValue;
  apiBaseUrl: string;
  isMixed?: boolean;
  onEditClick: (fieldId: number, currentValue: FieldValue) => void;
  onClearClick: (fieldId: number) => void;
  onValueChange: (fieldId: number, value: FieldValue) => void;
  onSave: (fieldId: number) => void;
  onCancel: () => void;
};

export const MetaFieldRow = ({
  field,
  isEditing,
  hasPendingChange,
  displayValue,
  editValue,
  apiBaseUrl,
  isMixed,
  onEditClick,
  onClearClick,
  onValueChange,
  onSave,
  onCancel,
}: Props) => {
  return (
    <tr key={field.id} className="border-b border-gray-100 hover:bg-gray-50">
      <td
        className="py-3 pr-4 pl-1 text-[12px] font-semibold text-gray-700"
        aria-required={field.required}
      >
        {field.name}
        {field.required && <span className="ml-1 text-red-500">*</span>}
      </td>
      <td className="py px-4">
        {isEditing ? (
          <FieldValueEditor
            field={field}
            value={editValue}
            apiBaseUrl={apiBaseUrl}
            onValueChange={onValueChange}
            onSave={onSave}
            onCancel={onCancel}
          />
        ) : (
          <FieldValueDisplay
            field={field}
            displayValue={displayValue}
            hasPendingChange={hasPendingChange}
            isMixed={isMixed}
            onEditClick={onEditClick}
            onClearClick={onClearClick}
          />
        )}
      </td>
    </tr>
  );
};
